export const replaceMailPreviewCidImages = (html, schoolAvatar) => {
  if (!html) {
    return "";
  }

  return html.replace(/<img\b([^>]*?)src=["']cid:logo["']([^>]*?)>/gi, (match, before, after) => {
    const attrs = `${before}${after}`.replace(/\sstyle=(["']).*?\1/gi, "");
    return `<img${attrs} src="/images/mealogo.png" style="margin:0;padding:0;border:0;max-width:140px;height:auto;">`;
  });
};
